var map = {
	"./demos/basic/index.ts": 39267,
	"./demos/closable/index.ts": 13797,
	"./demos/icon/index.ts": 29994,
	"./demos/size/index.ts": 22173,
	"./demos/title/index.ts": 97369
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 64098;